<template>
  <div class="push-task-list">

    <div class="task-container">
      <van-pull-refresh
        v-model="refreshing"
        @refresh="onRefresh"
      >
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div
            v-for="task in taskList"
            :key="task.id"
            class="task-item"
          >
            <div class="task-header">
              <div class="task-time">时间：{{ task.create_time }}</div>
              <div :class="['task-status', task.status_class]">{{ task.status_name }}</div>
            </div>
            <div class="task-content">
              <div class="task-sender">群发人群：{{ task.name }}</div>
              <div class="task-message">推送内容：{{ task.content }}</div>
              <!-- <div class="task-progress">
                进度：{{ task.progress || '0/3' }}
                <template v-if="task.status === 1">
                  <van-button
                    size="small"
                    type="primary"
                    class="task-action"
                    @click="takeTask(task)"
                  >
                    取任务
                  </van-button>
                </template>
              </div> -->
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import wecomAPI from "@/apis/wecom";
import { Toast } from "vant";
import getUserInfo from "@/models/userInfo";

export default {
  name: "PushTaskList",

  data() {
    return {
      loading: false,
      finished: false,
      refreshing: false,
      taskList: [],
      pageSize: 10,
      currentPage: 1,
      userInfo: {},
    };
  },

  methods: {
    // 获取任务列表
    async fetchTaskList(isRefresh = false) {
      try {
        const params = {
          create_user_type: 1, // 根据实际情况设置
          create_user_id: this.userInfo.user_id, // 根据实际情况设置
          //   page: this.currentPage,
          //   page_size: this.pageSize,
        };

        const data = await wecomAPI.getPushTaskList(params);

        // 处理任务状态样式
        const processedData = data.map((task) => ({
          ...task,
          status_class: this.getStatusClass(task.status),
          progress: `${task.current_progress || 0}/${task.total_progress || 3}`,
        }));

        if (isRefresh) {
          this.taskList = processedData;
        } else {
          this.taskList = [...this.taskList, ...processedData];
        }

        // 判断是否加载完成
        this.finished = processedData.length < this.pageSize;
      } catch (error) {
        Toast("获取任务列表失败");
      }
      this.loading = false;
    },

    // 获取状态对应的样式类
    getStatusClass(status) {
      const statusMap = {
        1: "status-processing", // 执行中
        9: "status-completed", // 已完成
        3: "status-failed", // 已取消
      };
      return statusMap[status] || "";
    },

    // 下拉刷新
    async onRefresh() {
      //   this.finished = false;
      //   this.currentPage = 1;
      //   await this.fetchTaskList(true);
      //   this.refreshing = false;
    },

    // 上拉加载
    onLoad() {
      //   this.currentPage += 1;
      //   this.fetchTaskList();
    },

    // 取任务
    async takeTask() {
      try {
        // 这里需要调用取任务的接口
        // await wecomAPI.takeTask(task.id);
        Toast("取任务成功");
        this.onRefresh();
      } catch (error) {
        Toast("取任务失败");
      }
    },
  },

  async created() {
    this.userInfo = await getUserInfo();
    this.fetchTaskList();
  },
};
</script>

<style lang="scss" scoped>
.push-task-list {
  height: 100vh;
  display: flex;
  flex-direction: column;

  .task-container {
    flex: 1;
    overflow-y: auto;
  }

  .task-item {
    padding: 16px;
    margin-bottom: 12px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    border-bottom: 1px solid #000;
    .task-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 12px;
      font-size: 14px;

      .task-time {
        color: #000;
      }

      .task-status {
        padding: 4px 8px;
        border-radius: 4px;
        font-size: 12px;

        &.status-processing {
          background-color: #f59a23;
          color: #fff;
        }

        &.status-completed {
          background-color: #52c41a;
          color: #fff;
        }

        &.status-failed {
          background-color: #ff4d4f;
          color: #000;
        }
      }
    }

    .task-content {
      font-size: 14px;
      color: #000;

      .task-sender,
      .task-message {
        margin-bottom: 8px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .task-progress {
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #000;

        .task-action {
          height: 28px;
          padding: 0 12px;
          background-color: #002d5c;
          border-color: #002d5c;
        }
      }
    }
  }
}
</style> 